<template>
  <!-- <tbody> -->
  <tr class="text-sm">
    <td class="py-2 px-3 border border-l-0" />
    <td class="py-2 px-3 border" />
    <td class="py-2 px-3 align-top border">
      {{ ad.name }}
    </td>
    <td class="py-2 align-top px-3 border text-right">
      {{ adTotalsFormatted.impressions }}
      <br />
      {{ adTotalsFormatted.cpi }}
    </td>
    <td class="py-2 align-top px-3 border text-right">
      {{ adTotalsFormatted.reach }}
      <br />
      {{ adTotalsFormatted.cpr }}
    </td>
    <td class="py-2 align-top px-3 border text-right">
      {{ frequency }}
    </td>
    <td class="py-2 align-top px-3 border text-right">
      {{ adTotalsFormatted.inlineLinkClicks }}
      <br />
      {{ pageviewsPerImpression }}% / {{ spendPerPageView }}
    </td>
    <td class="py-2 align-top px-3 border text-right">
      {{ adTotalsFormatted.offsiteConversions }} ({{ offsiteConversionsPerPageview }})
    </td>
    <td class="py-2 align-top px-3 border border-r-0 text-right">
      {{ adTotalsFormatted.spend }}
    </td>
  </tr>
  <!-- </tbody> -->
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    ad: { type: Object, required: true },
    adInsights: { type: Array, default: () => [] },
  },
  computed: {
    facebookAdTotals() {
      return this.adInsights
        .filter((adInsight) => adInsight.object_id === this.ad.id)
        .reduce(
          (acc, current) => ({
            impressions: acc.impressions + (current?.impressions || 0),
            reach: acc.reach + (current?.reach || 0),
            clicks: acc.clicks + (current?.clicks || 0),
            inlineLinkClicks: acc.inlineLinkClicks + (current?.inline_link_clicks || 0),
            offsiteConversions: acc.offsiteConversions + (current?.offsiteConversions || 0),
            spend: acc.spend + (current?.spend || 0),
          }),
          {
            impressions: 0,
            reach: 0,
            clicks: 0,
            inlineLinkClicks: 0,
            offsiteConversions: 0,
            spend: 0,
          }
        );
    },
    adTotalsFormatted() {
      const impressions = this.facebookAdTotals?.impressions || 0;
      const reach = this.facebookAdTotals?.reach || 0;
      const spend = (this.facebookAdTotals?.spend || 0) / 100;
      const cpi = impressions ? 1000 * (spend / impressions) : 0;
      const cpr = reach ? 1000 * (spend / reach) : 0;

      return {
        impressions: Numbro(impressions).format({ thousandSeparated: true }),
        cpi: Numbro(cpi).formatCurrency({ thousandSeparated: true, mantissa: 2 }),
        reach: Numbro(reach).format({ thousandSeparated: true }),
        cpr: Numbro(cpr).formatCurrency({ thousandSeparated: true, mantissa: 2 }),
        clicks: Numbro(this.facebookAdTotals?.clicks || 0).format({ thousandSeparated: true }),
        inlineLinkClicks: Numbro(this.facebookAdTotals?.inlineLinkClicks || 0).format({
          thousandSeparated: true,
        }),
        offsiteConversions: Numbro(this.facebookAdTotals?.offsiteConversions || 0).format({
          thousandSeparated: true,
        }),
        spend: Numbro(spend).formatCurrency({ thousandSeparated: true }),
      };
    },
    frequency() {
      const { reach, impressions } = this.facebookAdTotals;
      if (!reach) return 0;
      return Numbro(impressions / reach).format({ thousandSeparated: true, mantissa: 2 });
    },
    pageviewsPerImpression() {
      const { impressions, inlineLinkClicks } = this.facebookAdTotals;
      if (!impressions) return 0;
      return Numbro((inlineLinkClicks / impressions) * 100).format({
        thousandSeparated: true,
        mantissa: 2,
      });
    },
    offsiteConversionsPerPageview() {
      const { inlineLinkClicks, offsiteConversions } = this.facebookAdTotals;
      if (!inlineLinkClicks) return 0;
      return Numbro(offsiteConversions / inlineLinkClicks).format({
        output: 'percent',
        mantissa: 1,
      });
    },
    spendPerPageView() {
      const { inlineLinkClicks, spend } = this.facebookAdTotals;
      if (!inlineLinkClicks) return 0;
      return Numbro(spend / 100 / inlineLinkClicks).formatCurrency({
        thousandSeparated: true,
        mantissa: 2,
      });
    },
  },
};
</script>
